import { useEffect } from "react";
import { useSelector } from "react-redux";
import { RootState } from "src/redux/store";
import {
  EditActionOfIndividualInclusion,
  EditActionOfSelectCondition,
} from "../DisplayLabelsClass";
import ByCondition from "./byCondition";
import ByIndividualInclusion from "./byIndividualInclusion";
import { useIsIndividualInclusionNamingEnabled } from "../common/hooks/IsIndividualInclusionNamingEnabled";

function ManageMembersByEdit({ userGroupUniqueName, setCurrentStepState, setDisplayLabels }) {
  const isSpecialConditionChecked = useSelector(
    (rootState: RootState) => rootState.keyCondition.isSpecialConditionChecked
  );
  const isIndividualInclusionNamingEnabled = useIsIndividualInclusionNamingEnabled();

  useEffect(() => {
    if (isSpecialConditionChecked) {
      setDisplayLabels(new EditActionOfIndividualInclusion(isIndividualInclusionNamingEnabled));
    } else {
      setDisplayLabels(new EditActionOfSelectCondition());
    }
  }, [isSpecialConditionChecked]);

  return (
    <>
      {isSpecialConditionChecked ? (
        <ByIndividualInclusion
          setCurrentStepState={setCurrentStepState}
          setDisplayLabels={setDisplayLabels}
          userGroupUniqueName={userGroupUniqueName}
        />
      ) : (
        <ByCondition
          userGroupUniqueName={userGroupUniqueName}
          setCurrentStepState={setCurrentStepState}
          setDisplayLabels={setDisplayLabels}
        />
      )}
    </>
  );
}

export default ManageMembersByEdit;
